var Cards = require('../../lib/cards.js');

module.exports = function() {
    /**
     * Cards
     */
    var cards = new Cards;
    cards.setup('ul.cards', 'li', 'masonry');

    /**
     * Filtertron
     */
    $('.filtertron').filtertron('entries', {
        expander: '#filtertronExpander',
        cards: cards
    });
};
